import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FadeIn, Section, SectionTitle, Accent, pad2 } from './Shared';
import { Stars } from './HeaderSections';
import { OfferCard } from './CoreSections';
import { useCountdown } from '../hooks/useCountdown';
import { coachTestimonials } from '../data/testimonials';
import { faqs } from '../data/faqs';
import { ShieldCheck, Plus, Clock, Lock, BadgeCheckIcon, ArrowRightIcon, MailIcon, AtSignIcon, MapPinIcon } from 'lucide-react';
export const Testimonials2 = () => <Section className="bg-slate-950" data-id="element-172" data-mp="13a4r5ubdstpl">
    <FadeIn data-id="element-173" data-mp="ph5dzyz2nbl7">
      <SectionTitle sub={<span className="inline-flex flex-wrap items-center justify-center gap-2" data-id="element-175" data-mp="pgdjysl4hlx1">
            <Stars size={14} data-id="element-176" data-mp="tgnxqrf5pgmg" />
            <span className="font-semibold text-white" data-id="element-177" data-mp="tfuq7o8din39">4,9/5</span>
            <span data-id="element-178" data-mp="1h68k7kaiqw0h">· +150 trainers in heel Nederland</span>
          </span>} data-id="element-174" data-mp="phf2tj8drcpb">
        Wat <Accent data-id="element-179" data-mp="1lzbc7nzndxek">coaches</Accent> zeggen
      </SectionTitle>
    </FadeIn>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="31lw6s3sz5t97">
      {coachTestimonials.map((t, i) => <FadeIn key={t.name} delay={Math.min(i * 0.05, 0.2)} data-id="element-181" data-mp="2wovzjpke2kgi" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-id="element-182" data-mp="3bc7c9usb4ai7">
            <Stars data-id="element-183" data-mp="36l8qifojuk7k" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-184" data-mp="36kpj3swize7s">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-185" data-mp="3kf8hlt9clxkt">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-186" data-mp="3gaseu0v1769t">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-187" data-mp="3pd9yc7jaxkt4">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-188" data-mp="3pa5lklrrtgqu">{t.name}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500" data-id="element-189" data-mp="1zxka3zlvfccb">
                  <MapPinIcon size={11} aria-hidden="true" data-id="element-190" data-mp="1uziqndkj9b0b" /> {t.location} · Geverifieerde aankoop
                </p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Guarantee = () => <Section className="bg-slate-900/40" data-id="element-191" data-mp="7w0r9t49io6o">
    <FadeIn className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.05] p-6 md:grid-cols-[auto_1fr] md:gap-12 md:p-12" data-id="element-192" data-mp="7uzjbxijmht6">
      <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10 md:h-36 md:w-36" data-id="element-193" data-mp="huqb3rfpyipk">
        <div className="text-center" data-id="element-194" data-mp="mqxbz5t9d40n">
          <ShieldCheck size={36} className="mx-auto text-emerald-400" aria-hidden="true" data-id="element-195" data-mp="rj8bi7k36nso" />
          <p className="mt-1 font-display text-2xl font-black italic leading-none text-white md:text-3xl" data-id="element-196" data-mp="vlv4wcweogrz">7 dagen</p>
        </div>
      </div>
      <div className="text-center md:text-left" data-id="element-197" data-mp="10lzmk691vhjs">
        <h2 className="font-display text-3xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-5xl" data-id="element-198" data-mp="15j9kybef33jr">
          7 dagen garantie — <span className="text-emerald-400" data-id="element-199" data-mp="1fp1473hfjqe5">zonder vragen</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-200" data-mp="1anbq1eywuwlu">
          <p data-id="element-201" data-mp="15oicxnnjd7m7">Open de delen. Gebruik ze in je lessen.</p>
          <p className="text-lg font-semibold leading-snug text-white md:text-xl" data-id="element-202" data-mp="15r3fkevnrrl0">
            Niet wat je verwachtte binnen 7 dagen? Dan krijg je 100% van je geld terug.
          </p>
          <p data-id="element-203" data-mp="1yd64u22siv8q">Geen formulieren. Geen gedoe. Geen gezeur.</p>
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-204" data-mp="1tg5uvg2tl8cc">
          Minder dan 2% vraagt geld terug
        </p>
      </div>
    </FadeIn>
  </Section>;
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-950" data-id="element-205" data-mp="2h4p6o5l2w396">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-206" data-mp="2h5qiwddtyvsh">
        <FadeIn className="text-center lg:text-left" data-id="element-207" data-mp="2ccxc7jysxddr">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-208" data-mp="1wvz0ol44kq8v">
            Veelgestelde <Accent data-id="element-209" data-mp="21vlcqr87w0g3">vragen</Accent>
          </h2>
          <p className="mt-4 break-words text-slate-400" data-id="element-210" data-mp="1nv0wa1prygpr">
            Twijfel je nog? Mail ons via{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="font-medium text-sky-400 underline-offset-4 hover:underline" data-id="element-211" data-mp="1rwcnucs7lc0l">
              soportecentershop95@gmail.com
            </a>
          </p>
        </FadeIn>
        <FadeIn delay={0.05} data-id="element-212" data-mp="2kljkf683rrj7">
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-213" data-mp="2kks1ovzltoac">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={faq.q} data-id="element-214" data-mp="2au5qrf2u1lxz" data-mpi={i}>
                  <h3 data-id="element-215" data-mp="2atdx49sspyac">
                    <button id={`faq-q-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 rounded-md" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} data-id="element-216" data-mp="2ylb4nop7q45n">
                      <span className="text-base font-semibold text-white md:text-lg" data-id="element-217" data-mp="11lkcmg1f05b3">{faq.q}</span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-blue-600 text-white' : 'bg-white/5 text-slate-300'}`} aria-hidden="true" data-id="element-218" data-mp="wok6k54kf2jz">
                        <Plus size={16} data-id="element-219" data-mp="ivujryh7ptlt" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-220" data-mp="dwrmx1bdytox">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-221" data-mp="1uarki5mre790">
                        <p className="pb-5 pr-12 text-[15px] leading-relaxed text-slate-300 md:text-base" data-id="element-222" data-mp="2bcx4xu46hkve">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 uur per week sessies zoeken',
    costo: '156 uur per jaar'
  }, {
    sin: 'Lessen zonder structuur',
    costo: 'Leden die afhaken'
  }, {
    sin: 'Geen aanpassingen per niveau',
    costo: 'Nieuwe leden komen niet terug'
  }, {
    sin: 'Geen jaarprogramma',
    costo: 'Steeds dezelfde circuits'
  }, {
    sin: 'Zondagen scrollen voor ideeën',
    costo: 'Elk jaar hetzelfde liedje'
  }];
  return <Section className="bg-slate-900/40" data-id="element-223" data-mp="397hjcgfzobjc">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-224" data-mp="394brwujw0xkg">
        <SectionTitle data-id="element-225" data-mp="3460nx0g9xha5">
          Wat kost het je
          <br data-id="element-226" data-mp="348wl2mkas1xj" /> <Accent data-id="element-227" data-mp="2z7z1q6njx1ug">om het niet te hebben?</Accent>
        </SectionTitle>

        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-228" data-mp="2z7qrkmitcamy">
        <table className="w-full text-left" data-id="element-229" data-mp="2ua702kx3u1d2">
          <thead data-id="element-230" data-mp="2pifigzvxf5z2">
            <tr className="border-b border-white/10 bg-white/[0.04]" data-id="element-231" data-mp="2phxbp9bn19cw">
              <th scope="col" className="w-1/2 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-slate-400 md:px-6 md:text-sm" data-id="element-232" data-mp="2lglo19cbqy7c">
                Zonder Functionele Training 365
              </th>
              <th scope="col" className="w-1/2 border-l border-white/10 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-white md:px-6 md:text-sm" data-id="element-233" data-mp="2bi4ohnzblb9o">
                De echte prijs
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-234" data-mp="3ve0gccxi5rsw">
            {costs.map(row => <tr key={row.sin} data-id="element-235" data-mp="38eva8j3ejfu">
                <td className="px-4 py-4 text-sm leading-snug text-slate-400 md:px-6 md:text-base" data-id="element-236" data-mp="37dhhwaoziuf">{row.sin}</td>
                <td className="border-l border-white/10 px-4 py-4 text-sm font-medium leading-snug text-red-400 md:px-6 md:text-base" data-id="element-237" data-mp="3qefgm0aidff4">
                  <span className="inline-flex items-start gap-1.5" data-id="element-238" data-mp="3bogmq9pzkq5g">
                    <ArrowRightIcon size={14} className="mt-0.5 shrink-0 md:mt-1" aria-hidden="true" data-id="element-239" data-mp="3gfzrg2v1kg89" />
                    {row.costo}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-white md:text-xl" data-id="element-240" data-mp="37o67e6gb0ndx">
          Je volgende training kan anders…
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-slate-950 border-t border-white/5 !pb-28 md:!pb-24" data-id="element-241" data-mp="2e4zwjddv4vkz">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-242" data-mp="2a2v4gj32c70g">
        <FadeIn className="text-center lg:text-left" data-id="element-243" data-mp="2o24m7n6x396j">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-244" data-mp="2o2xoaauxlaic">
            Je kunt je volgende les <Accent data-id="element-245" data-mp="2x2kpownnugbe">improviseren</Accent> — of binnenlopen met alles geregeld.
          </h2>
          <p className="mt-4 font-display text-3xl font-black uppercase italic text-sky-400 md:text-4xl" data-id="element-246" data-mp="2t17gqdp9tx09">
            Jij kiest.
          </p>

          <div className="mt-8 inline-flex flex-col items-center gap-3 lg:items-start" data-id="element-247" data-mp="36raxwq9an0iu">
            <p className="inline-flex items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-red-400" data-id="element-248" data-mp="31ukhg1tku2ww">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-400" aria-hidden="true" data-id="element-249" data-mp="3gofk2q352vzn" />
              Laatste kans · prijs eindigt over
            </p>
            <p className="font-display text-5xl font-black tabular-nums leading-none tracking-tight text-white md:text-6xl" role="timer" aria-live="off" data-id="element-250" data-mp="3dzbm3tku1fgz">
              {pad2(hours)}
              <span className="text-slate-600" data-id="element-251" data-mp="348z2q4or7scf">:</span>
              {pad2(minutes)}
              <span className="text-slate-600" data-id="element-252" data-mp="307592gcz7olr">:</span>
              {pad2(seconds)}
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-253" data-mp="rh0qdvnxfjx">
              Daarna gaat hij omhoog. Deze prijs komt niet terug.
            </p>
          </div>

          <ul className="mt-8 hidden flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400 lg:flex" data-id="element-254" data-mp="3nveyrtdb8wi6">
            <li className="flex items-center gap-2" data-id="element-255" data-mp="3ixd5kfm67gsz"><Lock size={14} aria-hidden="true" data-id="element-256" data-mp="3iwbtq8xbyqa7" /> 100% veilig betalen</li>
            <li className="flex items-center gap-2" data-id="element-257" data-mp="2ch1dmw9xyv5u"><Clock size={14} aria-hidden="true" data-id="element-258" data-mp="2ci2ph2ys7lom" /> Toegang binnen 5 minuten</li>
            <li className="flex items-center gap-2" data-id="element-259" data-mp="27gvgx1oteigw"><ShieldCheck size={14} aria-hidden="true" data-id="element-260" data-mp="27k16sj59podo" /> 7 dagen garantie</li>
            <li className="flex items-center gap-2" data-id="element-261" data-mp="n1gx91utfp5r"><BadgeCheckIcon size={14} aria-hidden="true" data-id="element-262" data-mp="ryh3pdvkutxe" /> Eindbedrag vooraf zichtbaar · Geen verborgen kosten</li>
          </ul>
        </FadeIn>

        <FadeIn delay={0.05} className="mx-auto w-full max-w-md" data-id="element-263" data-mp="vyrdz2qek6i2">
          <OfferCard id="final-offer" footnote="Eenmalige betaling · Inclusief 7 dagen garantie" data-id="element-264" data-mp="10ran9ni24fh2" />
        </FadeIn>

        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-400 lg:hidden" data-id="element-265" data-mp="15pc6q9jeagt2">
          <li className="flex items-center gap-1.5" data-id="element-266" data-mp="1anx6k7uqiygz"><Lock size={13} aria-hidden="true" data-id="element-267" data-mp="1ar1hrp6mauh5" /> 100% veilig betalen</li>
          <li className="flex items-center gap-1.5" data-id="element-268" data-mp="1fp320dfs4zu7"><Clock size={13} aria-hidden="true" data-id="element-269" data-mp="1jpmxlckpfve8" /> Toegang binnen 5 minuten</li>
          <li className="flex items-center gap-1.5" data-id="element-270" data-mp="1jnkcn6yessgd"><ShieldCheck size={13} aria-hidden="true" data-id="element-271" data-mp="3hgg7b3lnt9qs" /> 7 dagen garantie</li>
          <li className="flex w-full items-center justify-center gap-1.5" data-id="element-272" data-mp="3lh01pzeulz98"><BadgeCheckIcon size={13} aria-hidden="true" data-id="element-273" data-mp="3lhjktjg8itou" /> Eindbedrag vooraf zichtbaar · Geen verborgen kosten</li>
        </ul>
      </div>
    </Section>;
};
export const Footer = () => <footer className="border-t border-white/5 bg-slate-950 px-5 py-12 md:px-8" data-id="element-274" data-mp="np9f4vot86eo">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-275" data-mp="11oiuxu93syi4">
      <div className="mx-auto max-w-sm text-center md:mx-0 md:text-left" data-id="element-276" data-mp="xl3115of5c94">
        <p className="font-display text-xl font-black uppercase italic tracking-tight text-white" data-id="element-277" data-mp="1bl3z6ddau5kw">
          Functionele Training <Accent data-id="element-278" data-mp="16lizu1u7vv7n">365™</Accent>
        </p>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-279" data-mp="16kq3lusvwo3r">
          door Center Shop Digital
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-280" data-mp="1gc3x9ly5mtoz">
          Het #1 kant-en-klare lessysteem voor functionele trainers en coaches.
          Want een goede les geven hoort je niet elke zondag van het jaar te
          kosten.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm text-slate-400 md:items-end" data-id="element-281" data-mp="1pb7kn24ctv9a">
        <a href="mailto:soportecentershop95@gmail.com" className="inline-flex items-center gap-2 break-all transition-colors duration-150 hover:text-white" data-id="element-282" data-mp="28x11ihvopch3">
          <MailIcon size={14} className="shrink-0" aria-hidden="true" data-id="element-283" data-mp="1zxdvtjvx9ki8" /> soportecentershop95@gmail.com
        </a>
        <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-284" data-mp="23y67ejs9o1ho">
          <AtSignIcon size={14} aria-hidden="true" data-id="element-285" data-mp="1q69isppt49q1" /> centershop.digital
        </a>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 md:flex-row md:justify-between" data-id="element-286" data-mp="1v15ogsnyuvlm">
      <p className="text-center md:text-left" data-id="element-287" data-mp="1laawr8ryb3ss">
        © {new Date().getFullYear()} Center Shop Digital. Alle rechten voorbehouden.
        Alle prijzen in euro (EUR).
      </p>
      <p className="flex gap-4" data-id="element-288" data-mp="1c935hanur387">
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-289" data-mp="1c81qww7mnylq">Algemene voorwaarden</a>
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-290" data-mp="147diof0hw2ir">Privacybeleid</a>
      </p>
    </div>
  </footer>;